import { render, staticRenderFns } from "./ProdesResiduosPampa.vue?vue&type=template&id=45939ce2&lang=pug"
import script from "./ProdesResiduosPampa.vue?vue&type=script&lang=js"
export * from "./ProdesResiduosPampa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports